import { render, staticRenderFns } from "./themify_icon.vue?vue&type=template&id=183772da&"
import script from "./themify_icon.vue?vue&type=script&lang=js&"
export * from "./themify_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports